/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Button } from '@smiles/voebiz-ui-kit';
import { useTranslation } from 'react-i18next';
import { RegistryComponentProps } from './types';

const RegistryComponent = ({ component, handler }: RegistryComponentProps) => {
  const { t } = useTranslation(component);

  return (
    <div className="registry-container">
      <div>
        <div className="baggage" />
      </div>
      <div className="registry-text">
        <h1>{t('title')}</h1>
        <p>{t('description')}</p>
        <Button id="registry-button" onClick={handler}>
          {t('button_text')}
        </Button>
      </div>
    </div>
  );
};

export default RegistryComponent;
